//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { partition } from 'lodash';

import { IContentLibraryItem } from '@apis/content-library/contentLibraryApiModel';
import { IDefaultInstagramAccount } from '@instagram-account/redux/account/instagramAccountModel';
import { UniversalItemType } from '@models/UniversalItemType';
import { IConnectedBrandInstagramBusinessAccounts } from '@apis/instagram-settings/gatewayInstagramSettingsApiModel';

export interface ISplitMentionedItems {
  atMentionedItems: IContentLibraryItem[];
  nonAtMentionedItems: IContentLibraryItem[];
}

export const splitMentionedItemsCombiner = (
  materializedItems: IContentLibraryItem[],
  defaultInstagramAccount: IDefaultInstagramAccount | undefined,
  connectedInstagramAccounts:
    | IConnectedBrandInstagramBusinessAccounts[]
    | undefined,
  isMultiHandleFeatureEnabled: boolean,
): ISplitMentionedItems => {
  if (!defaultInstagramAccount) {
    return {
      atMentionedItems: [],
      nonAtMentionedItems: [],
    };
  }

  const facebookInstagramItems = materializedItems.filter((contentItem) => {
    return (
      contentItem.itemType === UniversalItemType.Instagram ||
      contentItem.itemType === UniversalItemType.Facebook
    );
  });

  const [atMentionedItems, nonAtMentionedItems] = partition(
    facebookInstagramItems,
    (contentItem: IContentLibraryItem) => {
      const accountUsernamesSet = new Set(
        connectedInstagramAccounts?.map((account) =>
          account.username.toLowerCase(),
        ),
      );

      return contentItem.socialDetails?.mentionedUsers.find((socialUser) => {
        const socialUserName = socialUser.username.toLowerCase();
        if (isMultiHandleFeatureEnabled) {
          return accountUsernamesSet.has(socialUserName);
        } else {
          return (
            socialUserName === defaultInstagramAccount.username?.toLowerCase()
          );
        }
      });
    },
  );

  return {
    atMentionedItems,
    nonAtMentionedItems,
  };
};
